import Repository from "./Repository";

export default {
  getManagerEarnings(payload) {
    return Repository.get(`/manager-earning-stats/${payload}`);
  },
};
